import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { canAccessEntity, isOperator } from "@/lib/permissions";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import OperatorDashboard from "@/pages/OperatorDashboard";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import AuditLog from "@/pages/AuditLog";
import JobDetail from "@/pages/JobDetail";
import StartNewJob from "@/pages/forms/StartNewJob";
import LogProduction from "@/pages/forms/LogProduction";
import AddCost from "@/pages/forms/AddCost";
import AddExternal from "@/pages/forms/AddExternal";
import EntityPage from "@/components/EntityPage";
import MachineLoad from "@/pages/MachineLoad";

function Protected({ children, entity }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (entity && !canAccessEntity(user.role, entity)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function Home() {
  const { user } = useAuth();
  return isOperator(user.role) ? <OperatorDashboard /> : <Dashboard />;
}

const ENTITY_ROUTES = ["jobs", "team", "machines", "operations", "production", "costs", "utilization", "external"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Protected><Home /></Protected>} />
            <Route path="/jobs/:jobId" element={<Protected entity="jobs"><JobDetail /></Protected>} />
            <Route path="/reports" element={<Protected entity="reports"><Reports /></Protected>} />            <Route path="/machine-load" element={<Protected entity="load"><MachineLoad /></Protected>} />
            <Route path="/users" element={<Protected entity="users"><Users /></Protected>} />
            <Route path="/audit" element={<Protected entity="audit"><AuditLog /></Protected>} />
            <Route path="/forms/new-job" element={<Protected entity="jobs"><StartNewJob /></Protected>} />
            <Route path="/forms/log-production" element={<Protected entity="production"><LogProduction /></Protected>} />
            <Route path="/forms/add-cost" element={<Protected entity="costs"><AddCost /></Protected>} />
            <Route path="/forms/add-external" element={<Protected entity="external"><AddExternal /></Protected>} />
            {ENTITY_ROUTES.map((e) => (
              <Route key={e} path={`/${e}`} element={<Protected entity={e}><EntityPage entity={e} /></Protected>} />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
